import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Image from "../../assets/images/Images";
// import Images from "../../src/assests/Images"; // Commented out as assets might be missing
// import visibilityoff from "../assests/visibility_off.png"; // Commented out
// import visibilityon from "../assests/visibility_on.png"; // Commented out

const Login = () => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: {
      roleBasedSelect: "admin",
      username: "",
      password: "",
      phoneNumber: "",
    },
  });

  const navigate = useNavigate();
  const [isShow, setIsShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // const [error, setError] = useState(); // Unused for now

  const { roleBasedSelect } = watch();

  // Real Login Function
  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      const payload = {
        emailId: data.username,
        password: data.password,
      };

      const LOGIN_URL = process.env.REACT_APP_LOGIN_URL || "https://capi.2kvirtualworld.com/b2bfastbilling/api/auth/login";

      const response = await axios.post(LOGIN_URL, payload);

      if (response?.data) {
        // Store essential info in sessionStorage
        sessionStorage.setItem("login", "true");
        sessionStorage.setItem("userId", response.data.id);
        sessionStorage.setItem("rolebase", response.data.role);

        // Store full details in localStorage as requested (or as existing pattern)
        localStorage.setItem("companyDetails", JSON.stringify(response.data));

        toast.success("Login Successful!");
        navigate("/");
      }
    } catch (error) {
      console.error("Login Error:", error);
      const errorMessage = error.response?.data?.message || "Invalid credentials. Please try again.";
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="container-fluid min-vh-100 d-flex align-items-center justify-content-center tw-bg-gradient-to-br tw-from-blue-900 tw-via-blue-700 tw-to-indigo-900">
      <div className="card tw-shadow-2xl border-0" style={{ maxWidth: "450px", width: "100%", borderRadius: "20px", background: "rgba(255, 255, 255, 0.95)", backdropFilter: "blur(10px)" }}>
        <div className="card-body p-5">
          {/* Role Selection */}
          <div className="mb-3 position-relative">
            <Controller
              name="roleBasedSelect"
              control={control}
              rules={{ required: "This field is required" }}
              render={({ field }) => (
                <select
                  {...field}
                  className="form-select tw-bg-white tw-border-gray-300 tw-text-gray-700 focus:tw-ring-blue-500 focus:tw-border-blue-500"
                  style={{ cursor: "pointer" }}
                >
                  <option value="admin">Admin</option>
                  <option value="executive">Executive</option>
                </select>
              )}
            />
            {errors?.roleBasedSelect && (
              <div className="text-danger small mt-1">
                {errors.roleBasedSelect.message}
              </div>
            )}
          </div>

          {/* Header / Logo */}
          <div className="text-center mb-3">
            {/* Placeholder for Logo if Image is missing */}
            <div className="tw-bg-white-600 tw-text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-2" style={{ width: "60px", height: "60px" }}>
              <img src={Image?.fastbillinglogo} alt="logo" style={{ width: "100%", height: "100%" }} />
            </div>
            <h4 className="tw-text-gray-800 fw-bold mb-1">2K Inventory</h4>
            <p className="tw-text-gray-500 small">Sign in to your account</p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit(onSubmit)}>
            {/* Username / Phone Input */}
            <div className="mb-3">
              <label className="form-label tw-text-gray-700 fw-semibold small">
                {roleBasedSelect === "admin" ? "Username" : "Phone Number"}
              </label>
              <Controller
                name={roleBasedSelect === "admin" ? "username" : "phoneNumber"}
                control={control}
                rules={{ required: `${roleBasedSelect === "admin" ? "Username" : "Phone Number"} is required` }}
                render={({ field }) => (
                  <input
                    type={roleBasedSelect === "admin" ? "email" : "tel"}
                    {...field}
                    className="form-control form-control-sm tw-py-2 tw-border-gray-300 focus:tw-ring-blue-500 focus:tw-border-blue-500"
                    placeholder={roleBasedSelect === "admin" ? "Enter your username" : "Enter your phone number"}
                  />
                )}
              />
              {errors[roleBasedSelect === "admin" ? "username" : "phoneNumber"] && (
                <div className="text-danger small mt-1">
                  {errors[roleBasedSelect === "admin" ? "username" : "phoneNumber"]?.message}
                </div>
              )}
            </div>

            {/* Password Input */}
            <div className="mb-3">
              <label className="form-label tw-text-gray-700 fw-semibold">Password</label>
              <div className="input-group">
                <Controller
                  name="password"
                  control={control}
                  rules={{ required: "Password is required" }}
                  render={({ field }) => (
                    <input
                      type={!isShow ? "password" : "text"}
                      {...field}
                      className="form-control tw-py-2 tw-border-gray-300 focus:tw-ring-blue-500 focus:tw-border-blue-500"
                      placeholder="Enter your password"
                    />
                  )}
                />
                <button
                  className="btn btn-outline-secondary tw-bg-gray-200 tw-border-gray-300 hover:tw-bg-gray-300"
                  type="button"
                  onClick={() => setIsShow(!isShow)}
                >
                  {isShow ? (
                    <span className="tw-text-gray-600">Hide</span>
                  ) : (
                    <span className="tw-text-gray-600">Show</span>
                  )}
                </button>
              </div>
              {errors?.password && (
                <div className="text-danger small mt-1">
                  {errors.password.message}
                </div>
              )}
            </div>

            {/* Submit Button */}
            <div className="d-grid">
              <button
                type="submit"
                className="btn btn-primary tw-bg-blue-600 hover:tw-bg-blue-700 tw-border-none tw-py-2 fw-bold"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Signing in...
                  </>
                ) : (
                  "Sign In"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Login;
